import { render, staticRenderFns } from "./ApprovalInfoTabs.vue?vue&type=template&id=256fceac&scoped=true"
import script from "./ApprovalInfoTabs.vue?vue&type=script&lang=js"
export * from "./ApprovalInfoTabs.vue?vue&type=script&lang=js"
import style0 from "./ApprovalInfoTabs.vue?vue&type=style&index=0&id=256fceac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256fceac",
  null
  
)

export default component.exports